import { css, StyleSheet } from 'aphrodite';
import { forwardRef, InputHTMLAttributes, useId } from 'react';
import { FieldError } from 'react-hook-form';
import { Input } from '../../../../../web/components-v2/Input';
import { bs } from '../../../../../web/styles/styles';
import { InfoPopover } from '../../../../components/InfoPopover/InfoPopover';
import { Column, Row } from '../../../../components/Layout';
import { styleSheet } from '../../../../components/blogs/styles';

interface FontSizeInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
	error?: FieldError;
	label: string;
}

export const FontSizeInput = forwardRef<HTMLInputElement, FontSizeInputProps>(({ error, id, label, ...props }, ref) => {
	const generatedId = useId();
	const inputId = id ?? generatedId;

	return (
		<Column className={css(bs.justifyCenter)}>
			<Row className={css(styleSheet.labelRow)}>
				<label className={css(styleSheet.label)} htmlFor={inputId}>
					{label}
				</label>
				{!!error && <InfoPopover message={error.message} variant='error' />}
			</Row>
			<div className={css(fontSizeInputStyleSheet.inputShell)}>
				<Input
					aria-invalid={error ? 'true' : undefined}
					aria-label={`${label} (px)`}
					id={inputId}
					inputMode='numeric'
					ref={ref}
					styles={[fontSizeInputStyleSheet.input]}
					type='text'
					{...props}
				/>
				<span aria-hidden='true' className={css(fontSizeInputStyleSheet.addonText)}>
					px
				</span>
			</div>
		</Column>
	);
});
FontSizeInput.displayName = 'FontSizeInput';

const fontSizeInputStyleSheet = StyleSheet.create({
	inputShell: {
		position: 'relative',
		width: '100%',
	},
	input: {
		height: 42,
		paddingRight: 36,
		fontVariantNumeric: 'tabular-nums',
		textAlign: 'left',
	},
	addonText: {
		position: 'absolute',
		right: 12,
		top: '50%',
		transform: 'translateY(-50%)',
		pointerEvents: 'none',
		fontSize: 12,
		fontWeight: 700,
		letterSpacing: 0.24,
		textTransform: 'lowercase',
	},
});
